import apiClient from './apiClient';
import {
  EarningsDiscoveryRow,
  EarningsDiscoveryDetail,
} from '../types/earnings';

export const earningsService = {
  // Discovery
  getDiscoveryList: () =>
    apiClient.get<EarningsDiscoveryRow[]>('/api/discover/earnings').then((r) => r.data),

  getDiscoveryDetail: (ticker: string, earningsDate?: string, skipLive: boolean = false) =>
    apiClient
      .get<EarningsDiscoveryDetail>(`/api/discover/earnings/${ticker}`, {
        params: { ...(earningsDate ? { earnings_date: earningsDate } : {}), skip_live: skipLive },
      })
      .then((r) => r.data),

  // Trades — uses unified trades table
  listTrades: (params?: { ticker?: string; earnings_date?: string; status?: string }) =>
    apiClient.get('/api/earnings', { params }).then((r) => r.data),

  listTradesForEvent: (ticker: string, earningsDate: string) =>
    apiClient.get('/api/earnings', { params: { ticker, earnings_date: earningsDate } }).then((r) => r.data),

  getTrade: (id: number) =>
    apiClient.get(`/api/earnings/${id}`).then((r) => r.data),

  createTrade: (payload: Record<string, unknown>) =>
    apiClient.post('/api/earnings', payload).then((r) => r.data),

  addPosition: (_tradeId: number, _payload: Record<string, unknown>) =>
    Promise.resolve({}),  // No-op: legs are now stored as JSON in the trade itself

  closeTrade: (tradeId: number, payload: { close_date: string; close_reason: string; close_price?: number }) =>
    apiClient.post(`/api/earnings/${tradeId}/close`, payload).then((r) => r.data),

  getUnrealizedPnl: (_tradeId: number) =>
    Promise.resolve({ unrealized_pnl: null }),  // TODO: implement against unified table

  listPlays: (ticker?: string, earningsDate?: string) =>
    apiClient.get('/api/earnings/plays', { params: { ticker, earnings_date: earningsDate } }).then((r) => r.data),

  archivePlay: (ticker: string, earningsDate: string) =>
    Promise.resolve({}),  // No-op: plays concept removed

  deletePlay: (_playId: number) =>
    Promise.resolve(),
};
